<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div>
        <div class="bg-info m-b-30">
          <div class="container">
            <div class="row p-b-60 p-t-60">
              <div
                class="col-md-6 text-center mx-auto text-white p-b-30 spacer-image"
              >
                <p class="h4 text-dark">Patient Utilization Page</p>
              </div>
            </div>
          </div>
        </div>

        <section class="pull-up container">
          <div class="row">
            <div class="col-lg-3 col-md-3">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="pb-2">
                    <div class="avatar avatar-lg">
                      <div class="avatar-title bg-soft-info rounded-circle">
                        <i class="mdi mdi-medical-bag"></i>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="text-muted text-overline m-0">Encounters</p>
                    <h1 class="fw-400">
                      {{ records.meta.total | numeral("0,0") }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-3">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="pb-2">
                    <div class="avatar avatar-lg">
                      <div class="avatar-title bg-soft-info rounded-circle">
                        <i class="mdi mdi-bank-transfer"></i>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="text-muted text-overline m-0">Referrals</p>
                    <h1 class="fw-400">
                      {{ referrals.meta.total | numeral("0,0") }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-3">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="pb-2">
                    <div class="avatar avatar-lg">
                      <div class="avatar-title bg-soft-info rounded-circle">
                        <i class="mdi mdi-file-document-outline"></i>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="text-muted text-overline m-0">Claims</p>
                    <h1 class="fw-400">
                      {{ claims.data.length | numeral("0,0") }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-3">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="pb-2">
                    <div class="avatar avatar-lg">
                      <div class="avatar-title bg-soft-info rounded-circle">
                        <i class="mdi mdi-currency-ngn"></i>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="text-muted text-overline m-0">
                      Utilization (All time)
                    </p>
                    <h1 class="fw-400">
                      <i class="mdi mdi-currency-ngn"></i>
                      {{
                        (client.utilization_primary +
                          client.utilization_secondary)
                          | numeral("0,0")
                      }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="">
            <div class="row">
              <div class="col-lg-7 col-md-12 my-2">
                <div class="card">
                  <div class="card-body row">
                    <div class="col-md-4">
                      <img
                        :src="`https://claimify-api.hayokmedicare.ng/image/${client.user_image}`"
                        class="img spacer-top"
                        alt="User Photo"
                        onerror="this.onerror=null; this.src='/assets/img/ohis_logo.png'"
                      />
                    </div>

                    <div class="col-md-8">
                      <p class="spacer-top-bottom">
                        <span class="text-primary"> NAME: </span>
                        <strong> {{ client.full_name }}</strong>
                      </p>
                      <hr />
                      <p class="spacer-top-bottom">
                        <span class="text-primary"> ID NUMBER:</span>
                        {{ client.id_card_number }}
                      </p>
                      <hr />

                      <p class="spacer-top-bottom">
                        <span class="text-primary"> Account Type:</span>
                        <span>{{ client.account_type }}</span>
                      </p>
                      <hr />

                      <p class="spacer-top-bottom">
                        <span class="text-primary"> DOB:</span>
                        <span>{{ client.dob }}</span>
                      </p>
                      <hr />

                      <!-- <p class="spacer-top-bottom">
                        <span class="text-primary"> Provider:</span>
                        {{ client }} {{ healthFacility.agency_name }}
                      </p>
                      <hr /> -->

                      <p class="spacer-top-bottom">
                        <span class="text-primary">Phone Number:</span>
                        {{ client.phone_number }}
                      </p>
                      <hr />
                      <p class="spacer-top-bottom">
                        <span class="text-primary">Sector:</span>
                        <span v-if="$route.params.type == 'client'"
                          >{{ client.sector }}
                        </span>
                        <span v-else> {{ client.user.sector }} </span>
                      </p>
                      <hr />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-5 col-md-12 my-2">
                <div class="card">
                  <div class="card-header">
                    <div class="card-title h4">Authorization Codes</div>
                  </div>
                  <div class="card-body">
                    <div class="timeline">
                      <div
                        class="timeline-item"
                        v-for="auth_code in referrals.data"
                        v-bind:key="auth_code.id"
                      >
                        <div class="timeline-wrapper">
                          <div class="">
                            <div
                              class="avatar avatar-sm"
                              v-if="auth_code.status == 'in-progress'"
                            >
                              <div
                                class="avatar-title bg-primary rounded-circle"
                              >
                                <i class="mdi mdi-magnet"></i>
                              </div>
                            </div>
                            <div
                              class="avatar avatar-sm"
                              v-if="auth_code.status == 'rejected'"
                            >
                              <div
                                class="avatar-title bg-danger rounded-circle"
                              >
                                <i class="mdi mdi-alert-circle-outline"></i>
                              </div>
                            </div>

                            <div
                              class="avatar avatar-sm"
                              v-if="auth_code.status == 'pending'"
                            >
                              <div
                                class="avatar-title bg-warning rounded-circle"
                              >
                                <i class="fe fe-book-open"></i>
                              </div>
                            </div>

                            <div
                              class="avatar avatar-sm"
                              v-if="auth_code.status == 'approved'"
                            >
                              <div class="avatar-title bg-info rounded-circle">
                                <i class="mdi mdi-check-all"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col-auto">
                            <h6 class="m-0">
                              <router-link
                                :to="`/authorization-code/${auth_code.id}`"
                              >
                                {{
                                  auth_code.encounter.healthrecord.encounter_id
                                }}
                              </router-link>
                            </h6>
                            <button
                              v-if="auth_code.code_created != null"
                              class="btn m-b-15 ml-2 mr-2 badge badge-soft-secondary spacer"
                            >
                              {{ auth_code.code_created }}
                            </button>
                          </div>
                          <div class="ml-auto col-auto text-muted">
                            {{
                              auth_code.date_requested
                                | moment("ddd, MMM Do YYYY")
                            }}
                          </div>
                        </div>
                      </div>

                      <div class="timeline-item">
                        <div class="timeline-wrapper">
                          <div class="">
                            <div class="avatar avatar-sm">
                              <div class="avatar-title bg-info rounded-circle">
                                <i class="mdi mdi-account-circle"></i>
                              </div>
                            </div>
                          </div>
                          <div class="col-auto">
                            <h6 class="m-0">Enrolled on</h6>
                          </div>
                          <div class="ml-auto col-auto text-muted">
                            {{ client.created_at | moment("ddd, MMM Do YYYY") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 col-md-12" style="margin-top: 20px">
                <div class="card m-b-30">
                  <div class="card-header">
                    <!-- <div class="form-group"> -->
                    <p class="h4">Health Records</p>
                    <!-- </div> -->
                  </div>

                  <div class="card-body">
                    <div class="table-responsive">
                      <table class="table align-td-middle table-card">
                        <thead>
                          <tr>
                            <th>Encounter ID</th>
                            <th>Healthcare Provider</th>
                            <th>Diagnosis</th>
                            <th>Date Created</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="record in records.data"
                            v-bind:key="record.id"
                          >
                            <td>{{ record.healthrecord.encounter_id }}</td>

                            <td>{{ record.provider.agency_name }}</td>

                            <td>{{ record.diagnosis.name }}</td>
                            <td>
                              {{
                                record.created_at | moment("dddd, MMMM Do YYYY")
                              }}
                            </td>
                            <td>
                              <router-link
                                :to="{ path: '/encounter/' + record.id }"
                              >
                                <button
                                  type="button"
                                  class="btn btn-info"
                                  name="button"
                                >
                                  <i class="fe fe-eye"></i>
                                </button>
                              </router-link>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="container">
                <div class="row list">
                  <div class="col-lg-12 col-md-12">
                    <div class="card m-b-30">
                      <div class="card-header">
                        <p class="h4">Claims</p>
                      </div>

                      <div class="card-body">
                        <div class="table-responsive">
                          <table class="table align-td-middle table-card">
                            <thead>
                              <tr>
                                <th>SN</th>
                                <th>Health Facility</th>
                                <th>Patient</th>
                                <th>Diagnosis</th>
                                <th>Requested / Approved</th>
                                <th>Status</th>
                                <th>Date Created</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr
                                v-for="(claim, index) in claims.data"
                                v-bind:key="claim.id"
                              >
                                <td>{{ index + 1 }}</td>
                                <td>
                                  <span v-if="claim.provider">{{
                                    claim.provider.agency_name
                                  }}</span>
                                </td>
                                <td>
                                  <span v-if="claim.enrollee">
                                    {{ claim.enrollee.full_name }} (
                                    {{ claim.enrollee.id_card_number }} )
                                  </span>
                                </td>

                                <td>
                                  <span v-if="claim.diagnosis"
                                    >{{ claim.diagnosis.name }}
                                  </span>
                                </td>
                                <td>
                                  <i class="mdi mdi-currency-ngn"></i>
                                  {{
                                    claim.requested_total_cost | numeral(0, 0)
                                  }}
                                  /
                                  <i class="mdi mdi-currency-ngn"></i>
                                  {{
                                    claim.approved_total_cost | numeral(0, 0)
                                  }}
                                </td>
                                <td>
                                  <span v-if="claim.paymentorders >= 1">
                                    <button
                                      class="btn m-b-15 ml-2 mr-2 badge badge-soft-dark"
                                      v-if="
                                        claim.paymentorders[0].status ==
                                        'pending'
                                      "
                                    >
                                      processed for payment
                                    </button>

                                    <button
                                      class="btn m-b-15 ml-2 mr-2 badge badge-soft-success"
                                      v-if="
                                        claim.paymentorders[0].status == 'paid'
                                      "
                                    >
                                      <i class="fe fe-check-square"></i>paid
                                    </button>
                                  </span>

                                  <span v-if="claim.status == 1">
                                    <button
                                      type="button"
                                      class="btn m-b-15 ml-2 mr-2 badge badge-soft-success"
                                    >
                                      approved
                                    </button>
                                  </span>

                                  <span v-if="claim.verified_by_id != null">
                                    <button
                                      type="button"
                                      class="btn m-b-15 ml-2 mr-2 badge badge-soft-info"
                                    >
                                      verified
                                    </button>
                                  </span>
                                  <span v-if="claim.checked_by_id != null">
                                    <button
                                      type="button"
                                      class="btn m-b-15 ml-2 mr-2 badge badge-soft-dark"
                                    >
                                      vetted
                                    </button>
                                  </span>
                                  <span v-if="claim.status == 0">
                                    <button
                                      type="button"
                                      class="btn m-b-15 ml-2 mr-2 badge badge-soft-danger"
                                    >
                                      rejected
                                    </button>
                                  </span>
                                  <span v-if="claim.status == null">
                                    <button
                                      type="button"
                                      class="btn m-b-15 ml-2 mr-2 badge badge-soft-warning"
                                    >
                                      pending
                                    </button>
                                  </span>
                                </td>
                                <td>
                                  {{
                                    claim.created_at
                                      | moment("dddd, MMMM Do YYYY")
                                  }}
                                </td>
                                <td>
                                  <router-link
                                    :to="{ path: '/claim/' + claim.id }"
                                  >
                                    <button
                                      type="button"
                                      name="button"
                                      class="btn btn-outline-dark"
                                    >
                                      <i class="fe fe-eye"></i>
                                    </button>
                                  </router-link>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="vld-parent">
            <loading
              :active.sync="isLoading"
              loader="dots"
              :can-cancel="true"
              :is-full-page="fullPage"
            ></loading>
          </div>
        </section>
      </div>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      user: null,
      records: {
        data: [],
        meta: {
          total: 0,
        },
      },
      claims: {
        data: [],
      },
      referrals: {
        data: [],
        meta: {
          total: 0,
        },
      },
      client: "",
      notes: "",
      medications: "",
      healthFacility: "",
      signature: "",
      enrolled_by: "",
      ward: "",
      local_government: "",
      edit: false,
      isLoading: false,
      fullPage: true,
      agency_id: "",
      output: "",
      singletpa: "",
    };
  },

  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },

  methods: {
    fetchUser() {
      if (this.$route.params.type == "client") {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
          .then((response) => {
            this.client = response.data.user;
            this.healthFacility = response.data.provider;
            this.local_government = response.data.local_government;
            this.ward = response.data.ward;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.axios
          .get(`/api/v1/auth/getSpeicifDependant/${this.$route.params.id}`)
          .then((response) => {
            this.client = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },

    HRecord() {
      this.isLoading = true;
      this.axios
        .post(`/api/v1/auth/service_summary-agency`, {
          client_id:
            this.$route.params.type == "client" ? this.$route.params.id : null,
          dependent_id:
            this.$route.params.type != "client" ? this.$route.params.id : null,
          agency_id: 95930,
          paginate_value: 30,
        })
        .then((response) => {
          console.log(response);
          this.records = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
        });
    },
    getReferrals() {
      this.isLoading = true;
      this.axios
        .get(`/api/v1/auth/referrals-patient/${this.$route.params.id}`)
        .then((response) => {
          console.log(response);
          this.referrals = response.data;
          this.isLoading = false;
        })
        .catch((error) => {
          console.log(error.response);
          this.isLoading = false;
        });
    },

    getClaims() {
      this.isLoading = true;
      this.axios
        .get(`/api/v1/auth/claims/95930`, {
          params: {
            client_id:
              this.$route.params.type == "client"
                ? this.$route.params.id
                : null,
            dependent_id:
              this.$route.params.type != "client"
                ? this.$route.params.id
                : null,
            from: this.from,
            to: this.to,
          },
        })
        .then((response) => {
          this.claims = response.data;
          console.log(response);
          this.isLoading = false;
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },
  },
  created() {
    this.fetchUser();
    this.HRecord();
    this.getReferrals();
    this.getClaims();
  },
};
</script>
<style>
.spacer {
  margin-left: 1px;
  margin-top: 5px;
  margin-bottom: 5px;
}

.spacer-image {
  margin-top: 25px;
}

.spacer-top-bottom {
  margin-top: 10px;
  margin-bottom: 10px;
}

.spacer-top {
  margin-top: 10px;
}

#container {
  margin: 0px auto;
  width: 500px;
  height: 375px;
  border: 10px #333 solid;
}

#videoElement {
  width: 500px;
  height: 375px;
  background-color: #666;
}
</style>
